@if (noJobLeft()) {
  <div class="is-flex is-justify-content-center is-align-items-center is-fullheight">
    <h5 class="title is-size-5" translate="captureTransaction.empty"></h5>
  </div>
} @else {
  @if (isPremiumBank()) {
    <div class="mb-2 ml-5">
      <article class="message is-warning">
        <div class="message-body">
          <fino-icon class="has-text-warning" icon="Rating Star"></fino-icon>
          <p
            translate="captureTransaction.premiumBank"
            [translateParams]="{ premiumDocUrl: premiumDocUrl() }"
          ></p>
        </div>
      </article>
    </div>
  }

  <div class="columns">
    <div class="column is-9 is-8-widescreen darkmode-ignore">
      @if (rotatedDocUrl()) {
        <div class="field">
          <label class="mr-2" translate="captureTransaction.originalDocument"></label>
          <input
            id="switchExample"
            type="checkbox"
            name="switchExample"
            class="switch is-rounded"
            [checked]="useRotatedDocUrl()"
            (click)="toggleRotatedDocUrl()"
          />
          <label for="switchExample" translate="captureTransaction.rotated"> </label>
        </div>
      }
      @if (pdfUrl()) {
        <app-pdf-viewer viewerId="JobPdfViewer" [pdfUrl]="pdfUrl()"></app-pdf-viewer>
      }
    </div>
    @if (job(); as job) {
      <div class="column">
        @if (isQualityAssurance) {
          <article class="message is-primary">
            <div
              class="message-body"
              translate="captureTransaction.capturedBy"
              [translateParams]="{ capturedBy: job.capturedBy }"
            ></div>
          </article>
        }
        @if (statusIsClosed()) {
          <article class="message is-warning">
            <div class="message-body">Status: {{ job.status }}</div>
          </article>
        }

        <article
          class="message"
          [class.is-info]="!statusIsClosed()"
          [class.is-warning]="statusIsClosed()"
        >
          <div class="message-body">
            <p>
              Status {{ job.status }} by User {{ job.statusChangedBy }}
              @if (isValidDate(job.statusChangedAt)) {
                ({{ job.statusChangedAt | date: 'short' }})
              }
            </p>
            @if (isSMMUser()) {
              <app-unlock-transaction-list
                (unlockList)="unlockBalanceList()"
                [isLoading]="!unlockBalanceListSubscription.closed"
              ></app-unlock-transaction-list>
            }
          </div>
        </article>
        @if (documentIsHidden()) {
          <article class="message is-warning">
            <div class="message-body" translate="captureTransaction.hidden"></div>
          </article>
        }

        @if (showIbanCheck()) {
          <app-iban-check
            [newIban]="job.newIban"
            [oldIban]="job.oldIban"
            [id]="job.id"
            [previousJobId]="job.previousJobId"
            [isQualityAssurance]="isQualityAssurance"
            (checkSuccess)="ibanCheckSuccess($event)"
          ></app-iban-check>
        } @else {
          <div class="tabs is-toggle is-centered is-fullwidth navigation-tabs">
            <ul>
              @for (mode of modes | keyvalue; track mode.value) {
                <li
                  (click)="selectMode(mode.value)"
                  [class.is-active]="selectedMode() === mode.value"
                >
                  <a>
                    <b class="is-size-7" [class.has-text-grey]="selectedMode() !== mode.value">{{
                      mode.value + '.title' | translate
                    }}</b>
                    <div class="ml-2">
                      <app-transaction-counter
                        [isActive]="selectedMode() == mode.value"
                        [transactions]="transactions()[mode.value]"
                      ></app-transaction-counter>
                    </div>
                  </a>
                </li>
              }
            </ul>
          </div>

          @if (selectedMode() === modes.DIRECT_DEBITS) {
            <app-direct-debits
              [form]="directDebitsForm"
              [directDebits]="transactions().directDebits"
              (directDebitsSubmitted)="transactionChanged($event)"
            ></app-direct-debits>
          } @else if (selectedMode() === modes.RECIEVED_PAYMENTS) {
            <app-recieved-payments
              [form]="receivedPaymentsForm"
              [receivedPayments]="transactions().receivedPayments"
              (receivedPaymentsSubmitted)="transactionChanged($event)"
            ></app-recieved-payments>
          } @else if (selectedMode() === modes.STANDING_ORDERS) {
            <app-standing-orders
              [form]="standingOrdersForm"
              [standingOrders]="transactions().standingOrders"
              (standingOrdersSubmitted)="transactionChanged($event)"
            ></app-standing-orders>
          }

          <div class="divider"><p translate="captureTransaction.menu"></p></div>

          <form [formGroup]="loadNextDocumentForm">
            <fino-checkbox formControlName="loadNext" label="captureTransaction.loadNext">
            </fino-checkbox>
          </form>

          <div class="is-flex mt-2">
            @if (hasTransactions) {
              <button
                fino-button
                type="submit"
                [loading]="isSubmitLoading()"
                [primary]="true"
                (click)="openSubmitModal()"
                aria-label="Open Submit Modal"
              >
                <label class="mr-1" translate="captureTransaction.submit"></label>
              </button>
            }

            @if (hasTransactions && !isQualityAssurance) {
              <button
                fino-button
                [loading]="isSubmitLoading()"
                (click)="openSubmitModalQA()"
                class="ml-2"
                aria-label="Open Submit Modal QA"
              >
                <label class="mr-1" translate="captureTransaction.submitToQA"></label>
              </button>
            }

            @if (isQualityAssurance) {
              <button
                [loading]="isSubmitLoading()"
                class="ml-2"
                fino-button
                (click)="sendToAmetras()"
                aria-label="Send to Ametras"
              >
                <label class="mr-1" translate="captureTransaction.captureAgain"></label>
              </button>
            }
          </div>
        }

        @if (!isQualityAssurance && !isSMMUser()) {
          <app-report-document
            [jobId]="job.id"
            [transactions]="transactions()"
            (documentReported)="renderNextJob()"
          ></app-report-document>
        }
        <app-tenant-infos
          class="mt-2"
          [infos]="sidebarInfos() || job"
          [hideIbans]="showIbanCheck()"
        ></app-tenant-infos>
      </div>
    }
  </div>
}
